import React from 'react';
import { Box, Typography } from '@mui/material';
import NewsUpdatesPanel from '../../components/News/NewsUpdatesPanel';

export default function NewsPage() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Birthday celebrations & updates
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Celebrate student and team birthdays for the next 7 days, plus announcements.
      </Typography>
      <Box sx={{ maxWidth: 640 }}>
        <NewsUpdatesPanel compact={false} />
      </Box>
    </Box>
  );
}
